import { createContext } from "react";
import { DEFAULT_LOCALE } from "../constants/localisation";
export var initialContextValue = {
    lps: {
        authorizedEntities: {},
        authorizedLps: null,
        lpSelected: null,
        authorizedDSPs: null
    },
    localization: {
        locale: DEFAULT_LOCALE
    }
};
var CarrierLogisticsCommonsContext = createContext(initialContextValue);
export default CarrierLogisticsCommonsContext;

//# sourceMappingURL=CarrierLogisticsCommonsContext.js.map